
export class GridStorage {
  private tableId: string;

  private static KEYS = {
    LAST_URL: 'lastUrl',
    LAST_GRID_STATE: 'lastGridState',
    LAST_COUNT: 'lastCount'
  }
  
  constructor(tableId: string) {
    this.tableId = tableId;
  }

  private getKey(suffix: string): string {
    return `${this.tableId}__${suffix}`;
  }

  private getLocalStorageData(key: string): any {
    const data = localStorage.getItem(this.getKey(key));
    return data ? JSON.parse(data) : undefined;
  }

  private setLocalStorageData(key: string, data: any): void {
    localStorage.setItem(this.getKey(key), JSON.stringify(data));
  }

  public getLastUrl(): string | undefined {
    return this.getLocalStorageData(GridStorage.KEYS.LAST_URL);
  }

  public setLastUrl(url: string): void {
    this.setLocalStorageData(GridStorage.KEYS.LAST_URL, url);
  }

  public getLastGridState(): any {
    return this.getLocalStorageData(GridStorage.KEYS.LAST_GRID_STATE);
  }

  public setLastGridState(gridState: any): void {
    this.setLocalStorageData(GridStorage.KEYS.LAST_GRID_STATE, gridState);
  }

  public getLastCount(): number | undefined {
    return this.getLocalStorageData(GridStorage.KEYS.LAST_COUNT);
  }

  public setLastCount(count: number): void {
    return this.setLocalStorageData(GridStorage.KEYS.LAST_COUNT, JSON.stringify(count))
  }
}

// Usage
export function useGridStorage(tableId: string) {
  return new GridStorage(tableId);
}
